import { render, staticRenderFns } from "./DialogCustomersSegmentsFilterCustomDelete.vue?vue&type=template&id=eb947b7e&"
import script from "./DialogCustomersSegmentsFilterCustomDelete.vue?vue&type=script&lang=js&"
export * from "./DialogCustomersSegmentsFilterCustomDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports